import { useEffect, useState } from "react";

/**
 * ReadingProgress — a thin gold bar fixed to the top of the viewport that
 * grows as the user scrolls through an article. Purely presentational.
 * Wrap it as a sibling inside any long-form article page.
 */
const ReadingProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let ticking = false;
    const compute = () => {
      const doc = document.documentElement;
      const total = doc.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      setPct(total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(compute);
        ticking = true;
      }
    };
    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      aria-hidden
      data-testid="reading-progress"
      className="fixed top-0 left-0 right-0 h-[3px] z-[60] bg-transparent pointer-events-none"
    >
      <div
        className="h-full bg-[hsl(var(--accent))] transition-[width] duration-150 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ReadingProgress;
